import React from "react";
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

import styles from "./details_header.module.css";
import { formatTimezoneDate, pduiIsReady } from "../../../../utils/utils";
import StatusDot from "../../../../components/status_dot";

export default function DetailsHeader({ pdui_id, pduiData, onSecretTap }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const goBack = () => {
    navigate("/list");
  };

  const arrow = (
    <FontAwesomeIcon
      icon={faChevronRight}
      color={"#ED8B00"}
      className={"px-2"}
      size={"xs"}
    />
  );

  const isReady = pduiIsReady(pduiData?.last_heartbeat);

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.pduiBreadcrumb}>
          <div onClick={goBack}>PDUI's</div>
          {arrow}
          <div onClick={onSecretTap} style={{ cursor: onSecretTap ? "pointer" : undefined }}>{pduiData?.name}</div>
          {arrow}
          <div>{t('detail.breadcrumbDetails')}</div>
        </div>
        {pduiData && pduiData.last_heartbeat && (
          <div className={styles["last-connection"]}>
            <StatusDot isReady={isReady} />
            <span className={styles.label}>{t('detail.lastConnection')}</span>
            <span className={styles["date-time"]}>
              {formatTimezoneDate(pduiData.last_heartbeat)}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
